import React, { useEffect, useRef, useState } from 'react';
import styles from './NewServices.module.css';

import tile1 from '../images/בית של שקט ואור 1.webp';
import tile2 from '../images/בית מדברי מודרני 1.webp';
import tile3 from '../images/בית של יוקרה וחומר 1.webp';

const SERVICES = [
  {
    num: '01',
    roman: 'I',
    sub: 'ARCHITECTURAL \u00B7 PLANNING',
    title: '\u05EA\u05DB\u05E0\u05D5\u05DF \u05D0\u05D3\u05E8\u05D9\u05DB\u05DC\u05D9',
    brief:
      '\u05EA\u05D9\u05E7 \u05EA\u05DB\u05E0\u05D9\u05D5\u05EA \u05D1\u05D9\u05E6\u05D5\u05E2 \u05DE\u05E4\u05D5\u05E8\u05D8 - \u05DB\u05DC \u05E9\u05E7\u05E2, \u05DB\u05DC \u05E4\u05E8\u05D8, \u05D1\u05DC\u05D9 \u05D1\u05D9\u05E8\u05D5\u05E7\u05E8\u05D8\u05D9\u05D4.',
    tile: tile1,
    featured: false,
  },
  {
    num: '02',
    roman: 'II',
    sub: 'PERMIT \u00B7 LEAD',
    title: '\u05EA\u05DB\u05E0\u05D5\u05DF + \u05DC\u05D9\u05D5\u05D5\u05D9 \u05E8\u05D9\u05E9\u05D5\u05D9',
    brief:
      '\u05DE\u05D4\u05E8\u05E2\u05D9\u05D5\u05DF \u05D5\u05E2\u05D3 \u05D4\u05D7\u05EA\u05D9\u05DE\u05D4 \u05E9\u05DC \u05D4\u05D5\u05D5\u05E2\u05D3\u05D4 - \u05D1\u05DC\u05D9 \u05E9\u05EA\u05D9\u05DB\u05E0\u05E1\u05D5 \u05DC\u05E2\u05D9\u05E8\u05D9\u05D9\u05D4 \u05E4\u05E2\u05DD \u05D0\u05D7\u05EA.',
    tile: tile2,
    featured: true,
  },
  {
    num: '03',
    roman: 'III',
    sub: 'TURNKEY \u00B7 FULL SERVICE',
    title: '\u05DC\u05D9\u05D5\u05D5\u05D9 \u05DE\u05DC\u05D0',
    brief:
      '\u05D0\u05D3\u05E8\u05D9\u05DB\u05DC\u05D9\u05EA \u05D0\u05D7\u05EA, \u05DE\u05D4\u05D4\u05EA\u05D7\u05DC\u05D4 \u05D5\u05E2\u05D3 \u05D4\u05DB\u05D5\u05E1\u05D5\u05EA \u05E2\u05DC \u05D4\u05E9\u05D9\u05E9.',
    tile: tile3,
    featured: false,
  },
];

const WA_LINK =
  'https://wa.me/972504499737?text=%D7%94%D7%99%D7%99%2C%20%D7%90%D7%A9%D7%9E%D7%97%20%D7%9C%D7%A9%D7%99%D7%97%D7%AA%20%D7%99%D7%99%D7%A2%D7%95%D7%A5%20%D7%97%D7%99%D7%A0%D7%9D';

export default function NewServices() {
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);
  const [visible, setVisible] = useState(() => new Set());
  const prefersReduced = useRef(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    prefersReduced.current = mq.matches;
  }, []);

  useEffect(() => {
    const cards = cardRefs.current.filter(Boolean);
    if (!cards.length) return undefined;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.dataset.idx);
            const delay = prefersReduced.current ? 0 : idx * 120;
            setTimeout(() => {
              setVisible((prev) => {
                const next = new Set(prev);
                next.add(idx);
                return next;
              });
            }, delay);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    cards.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <section
      id="services"
      ref={sectionRef}
      className={styles.section}
      dir="rtl"
    >
      {/* Header */}
      <header className={styles.header}>
        <span className={styles.eyebrow}>STUDIO &middot; SERVICES</span>
        <h2 className={styles.title}>
          <span className={styles.titleLine}>
            {'\u05E9\u05DC\u05D5\u05E9\u05D4 \u05DE\u05E1\u05DC\u05D5\u05DC\u05D9\u05DD,'}
          </span>
          <span className={styles.titleLineItalic}>
            {'\u05DC\u05DB\u05DC \u05E9\u05DC\u05D1 \u05E9\u05DC \u05D4\u05D3\u05E8\u05DA.'}
          </span>
        </h2>
        <p className={styles.lead}>
          {'\u05D1\u05D7\u05E8\u05D5 \u05D0\u05EA \u05E0\u05E7\u05D5\u05D3\u05EA \u05D4\u05DB\u05E0\u05D9\u05E1\u05D4 \u05E9\u05DE\u05EA\u05D0\u05D9\u05DE\u05D4 \u05DC\u05E4\u05E8\u05D5\u05D9\u05E7\u05D8 \u05E9\u05DC\u05DB\u05DD.'}
        </p>
      </header>

      {/* Bento Grid */}
      <div className={styles.grid}>
        {SERVICES.map((svc, i) => (
          <article
            key={svc.num}
            ref={(el) => {
              cardRefs.current[i] = el;
            }}
            data-idx={i}
            className={[
              styles.card,
              svc.featured ? styles.cardFeatured : '',
              visible.has(i) ? styles.cardVisible : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {/* Watermark */}
            <span className={styles.watermark}>{svc.num}</span>

            {/* Image */}
            <div className={styles.imageWrap}>
              <img
                src={svc.tile}
                alt={svc.title}
                className={styles.image}
                loading="lazy"
                decoding="async"
              />
              <div className={styles.imageTint} />
              {svc.featured && (
                <span className={styles.chip}>
                  {'\u05D4\u05DE\u05E1\u05DC\u05D5\u05DC \u05D4\u05DE\u05D5\u05DE\u05DC\u05E5'}
                </span>
              )}
            </div>

            {/* Content */}
            <div className={styles.content}>
              <span className={styles.meta}>
                {svc.roman} &mdash; {svc.sub}
              </span>
              <h3 className={styles.cardTitle}>{svc.title}</h3>
              <hr className={styles.rule} />
              <p className={styles.brief}>{svc.brief}</p>
              <span className={styles.cta}>
                {'\u05E4\u05E8\u05D8\u05D9\u05DD \u05DE\u05DC\u05D0\u05D9\u05DD'}{' '}
                <span className={styles.arrow}>&larr;</span>
              </span>
            </div>
          </article>
        ))}
      </div>

      {/* Footnote */}
      <p className={styles.footnote}>
        {'\u05DC\u05D0 \u05D1\u05D8\u05D5\u05D7\u05D9\u05DD \u05D0\u05D9\u05D6\u05D4 \u05DE\u05E1\u05DC\u05D5\u05DC \u05DE\u05EA\u05D0\u05D9\u05DD? \u05E0\u05E4\u05D2\u05E9\u05D9\u05DD \u05DC\u05E9\u05D9\u05D7\u05EA \u05D4\u05D9\u05DB\u05E8\u05D5\u05EA \u05E9\u05DC 20 \u05D3\u05E7\u05D5\u05EA - \u05DC\u05DC\u05D0 \u05E2\u05DC\u05D5\u05EA.'}
      </p>

      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.ctaBtn}
      >
        {'\u05DC\u05E9\u05D9\u05D7\u05EA \u05D9\u05D9\u05E2\u05D5\u05E5 \u05D7\u05D9\u05E0\u05DD'}
      </a>
    </section>
  );
}
